/** biome-ignore-all lint/complexity/noForEach: <explanation> */

import { getTextForLanguage } from '@cobliteam/ui-business/utils';
import type { PageDef, RouteDef } from '../../../dashboardDef';

const getPagesFlatted = (router: RouteDef[], parentTitle?: string, categoryParent?: string, parentId?: string, language = 'pt-BR'): PageDef[] => {
  const routes: PageDef[] = [];

  router.forEach((route) => {
    // Find the first parent with a page.title in the ancestry
    const firstParentTitle = parentTitle;
    // Track the immediate category parent
    const currentCategoryParent = categoryParent;

    // Add current route if it has sidebar title (regardless of URL)
    if (route.sidebar.title) {
      const sidebarTitle = getTextForLanguage(route.sidebar.title, language);
      routes.push({
        title: sidebarTitle,
        description: getTextForLanguage(route.page?.description, language),
        url: route.url || '',
        id: route.id,
        sidebar: route.sidebar,
        // Add first parent category page.title if available
        ...(firstParentTitle ? { primary: firstParentTitle, primaryId: parentId } : {}),
        // Add category parent if available
        ...(currentCategoryParent === firstParentTitle ? { group: undefined } : { group: currentCategoryParent }),
      });
    }

    if (route.routes) {
      // Pass down the first parent title, or use current route's page.title if no parent title exists
      const nextParentTitle = firstParentTitle || getTextForLanguage(route.page?.title, language);
      const nextParentId = route.id;
      // Pass down the current route's sidebar title as the category parent for child routes
      const nextCategoryParent = getTextForLanguage(route.sidebar.title, language);
      routes.push(...getPagesFlatted(route.routes, nextParentTitle, nextCategoryParent, nextParentId, language));
    }
  });

  return routes;
};

export default getPagesFlatted;
